import type { FetchSiteOptionsResponse } from 'services/content/site-options/types'

export default (data: FetchSiteOptionsResponse) => {
  const {
    emailOfTheDay,
    copyrightText,
    findABox,
    footerBackgroundImage,
    legalLabelText,
  } = data.footer

  return {
    copyrightText,
    emailOfTheDay,
    findABoxLink: {
      url: findABox.findABoxLinkUrl,
      text: findABox.findABoxLinkText,
    },
    image: {
      src: {
        ...footerBackgroundImage.sizes,
      },
    },
    legalLabelText,
  }
}
